import { AvailableChildrenType, SugarElementInfo } from "../../Suggester/SugarElementInfo";

export const addRowButton: SugarElementInfo = {
    name: "addRowButton",
    availableChildren: { type: AvailableChildrenType.Any },
};
